import type { ConfigTreeNode } from '../types';

/** Config keys whose UI value is 2× API value; user input is halved when sending to API. */
export const MIN_SIZE_BYTES_DOUBLE_DISPLAY_FIELDS = [
  'shrink.min_size_bytes',
  'datafy.min_size_bytes',
] as const;

/**
 * Recursively search for a node in the tree by ID
 */
export const findNodeInTree = (
  tree: ConfigTreeNode | null,
  nodeId: string
): ConfigTreeNode | null => {
  if (!tree) {
    return null;
  }

  const search = (node: ConfigTreeNode): ConfigTreeNode | null => {
    if (node.id === nodeId) {
      return node;
    }
    if (node.children) {
      for (const child of node.children) {
        const found = search(child);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  return search(tree);
};

// Format field names for display (e.g., "shrink.threshold_abort" -> "Shrink Threshold Abort")
export const formatFieldDisplayName = (fieldName: string): string => {
  return fieldName.replace(/[._]/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};

export const transformErrorMessage = (errorMessage: string): string => {
  return errorMessage.replace(/parameter\s+([a-z_][a-z0-9_.]*):/gi, (match, fieldName) => {
    const formattedFieldName = formatFieldDisplayName(fieldName);
    return match.replace(fieldName, formattedFieldName);
  });
};
